export default __webpack_public_path__ + "static/media/dbs-bank.10b586d1.svg";